module.exports = "span {\n  position: absolute; }\n\nspan i {\n  position: absolute;\n  display: block;\n  top: -4px;\n  z-index: 1000;\n  color: #777;\n  padding: 3px 5px;\n  border-radius: 3px;\n  left: 1px; }\n\ni:hover {\n  background: #46b8da;\n  color: white !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search-field/search-field.component.scss
// module id = 1139
// module chunks = 1